import styled from 'styled-components'
import PanelButton from '@pc/components/Works/Panel/shared/button/PanelButton'

const AreaPanelButton = styled(PanelButton)`
  flex-grow: 1;
  height: 40px;
  min-width: 120px;

  &:not(:first-of-type) {
    margin-left: 10px;
  }
`

export default AreaPanelButton
